import React from "react";
import { SectionHeading } from "./ui";
import { Reveal } from "./useReveal";

const SHOTS = [
  { label: "Coastal Living", area: "Orange County", img: "https://images.unsplash.com/photo-1612203575503-90d3db9b75d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", span: "lg:col-span-2 lg:row-span-2 h-[280px] lg:h-full" },
  { label: "Palm-Lined Streets", area: "Los Angeles", img: "https://images.unsplash.com/photo-1580655653885-65763b2597d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", span: "h-[200px]" },
  { label: "Resort-Style Homes", area: "Inland Communities", img: "https://images.unsplash.com/photo-1635111300299-e6e677daf7b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", span: "h-[200px]" },
  { label: "Beachside Sunsets", area: "SoCal Coast", img: "https://images.unsplash.com/photo-1647152548885-4881b06bfdd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", span: "h-[200px]" },
  { label: "Mediterranean Estates", area: "Southern California", img: "https://images.pexels.com/photos/5223143/pexels-photo-5223143.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800", span: "h-[200px]" },
];

export const GallerySection = () => (
  <section className="py-16 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Explore The Region"
          title="Life in Southern California"
          subtitle="From the coast to the hills, discover the communities where Wallstreet Realty helps buyers, sellers, and agents thrive."
        />
      </Reveal>
      <Reveal delay={100}>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:auto-rows-[200px]">
          {SHOTS.map((s, i) => (
            <div
              key={i}
              data-testid={`gallery-tile-${i}`}
              className={`relative rounded-[20px] overflow-hidden group ${s.span} ${i === 0 ? "col-span-2" : ""}`}
            >
              <img
                src={s.img}
                alt={`${s.label} — ${s.area}`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2D2D37]/85 via-[#2D2D37]/10 to-transparent" />
              <div className="absolute bottom-0 left-0 p-5">
                <p className="text-[#C9A961] text-[11px] font-heading font-bold uppercase tracking-[0.16em]">{s.area}</p>
                <p className="text-white font-heading font-bold text-lg leading-tight mt-0.5">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
